var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDedicatedSliderimg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1920.9,
    height: 1104.4,
    viewBox: "0 0 1920.9 1104.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d4d4dc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6a6a6e",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bebec5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6a6a6e",
    stopOpacity: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_269",
    "data-name": "Group 269",
    transform: "translate(0.1 -2408.4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_190",
    "data-name": "Group 190",
    transform: "translate(-5684.5 -82)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_112",
    "data-name": "Rectangle 112",
    width: 1920,
    height: 1102,
    transform: "translate(5685 2492)",
    fill: "#ededf5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_320",
    "data-name": "Path 320",
    d: "M5575,2491.2v496l-309,607.6H3655.2v-656l286,556,717.2-1004.4Z",
    transform: "translate(2029.8)",
    fill: "#f4f5fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321",
    "data-name": "Path 321",
    d: "M4331.2,2490.4h328L3870.4,3592.8h-216V3421.6Z",
    transform: "translate(2030)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_322",
    "data-name": "Path 322",
    d: "M4615.2,2490.4h44L3942.4,3592.8l-46-94Z",
    transform: "translate(2071)",
    opacity: 0.4,
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_323",
    "data-name": "Path 323",
    d: "M7299.167,3594,7605.3,2984.933V3594Z",
    fill: "#dedee6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDedicatedSliderimg);
export default __webpack_public_path__ + "static/media/dedicatedSliderimg.ba97df3b8781b809d15212bde082a4ee.svg";
export { ForwardRef as ReactComponent };